@if (showToolbarActions()) {
    <div class="betslip-picks-toolbar__settings">
        <i class="theme-settings-i" *msShowInEpcot="false" (click)="openSettingsDialog()"> </i>
        <i class="theme-settings" *msShowInEpcot="true" (click)="openSettingsDialog()"> </i>
    </div>

    <span class="betslip-picks-toolbar__remove-all">
        <div class="betslip-picks-toolbar__remove-all-request" (click)="requestRemoveAllPicks()">
            <span class="theme-bin betslip-picks-toolbar__remove-all-icon" *msShowInEpcot="false"> </span>
            <span class="theme-ex" *msShowInEpcot="true"> </span>
            <span class="betslip-picks-toolbar__remove-all-message betslip-picks-toolbar__clear-all-message" *msShowInEpcot="true">{{
                messages.clearAllMessage
            }}</span>
        </div>
    </span>
}
